























































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  hotSearch,
  queryPrefix,
  delHistory,
  getCueWord,
  delSingleHistory,
} from "@/req/home";
import { logout } from "@/req/user";
import Amend from "../Amend/index.vue";
import Enroll from "../Enroll/index.vue";
import messageTab from "@/components/messageTab.vue";
import rightSidebar from "@/components/rightSidebar.vue";
@Component({
  components: {
    Amend,
    Enroll,
    messageTab,
    rightSidebar,
  },
})
export default class Home extends Vue {
  public intShow = false;
  public imgShow = false;
  public showToTop = false;
  public showSearch = false; // 显示热门搜索历史搜索
  public showQuery = false; // 显示模糊查询列表
  public cueword = ""; // 推荐游戏
  public game = ""; // 游戏
  public hotList: any = [
    {
      name: "1.76版本",
      game_id: 1,
    },
  ];
  public historyList: any = [];
  public fuzzyList: any = [];
  public routeActive = false;
  public limit = 0;
  public navList = [
    {
      name: "首页",
      path: "/home/index",
    },
    // {
    //   name: "资讯",
    //   path: "/news",
    // },
    {
      name: "资讯",
      path: "/news",
    },
    {
      name: "下载",
      path: "/downloads",
    },
    {
      name: "开发者平台",
      path: "kaifa",
    },
  ];
  // 消息盒子
  // public async message() {
  //   const $messageTab: any = this.$refs.messageTab;
  //   const res = await $messageTab.show();
  // }
  public toPath(paths, index) {
    if (paths == "kaifa") {
      window.open("https://996m2.com", "_blank");
      return false;
    }
    this.limit = index;
    this.$router.push({ path: paths });
  }
  @Watch("$route")
  public change() {
    // 防止页面刷新，导航栏失去焦点
    for (let i = 0; i < this.navList.length; i++) {
      if (this.navList[i].path == this.$route.path) {
        this.limit = i;
      }
    }
    if (this.$route.path == "/downloads") {
      this.routeActive = true;
    } else if (this.$route.name == "gameDetail") {
      this.routeActive = true;
    } else {
      this.routeActive = false;
    }
  }
  // 获取随机搜索默认词
  public async getWord() {
    if (this.$route.path == "/search") {
      return false;
    }
    const res = await getCueWord({ token: this.$fn.cookies.getToken() });
    this.cueword = res.data.cueword;
  }
  // 修改密码
  public async changePassword() {
    // this.$router.push({ path: "/home/logina", query: { id: "1" } });
    const $changePassword: any = this.$refs.changePassword;
    const res = await $changePassword.show(1);
  }
  // 点击搜索
  public searchGame() {
    this.$router.push({
      path: "/search",
      query: { game: this.game ? this.game : this.cueword },
    });

    if (!this.$store.state.user.info) {
      if (this.historyList.length < 5) {
        this.historyList.unshift({ name: this.game });
      } else {
        this.historyList.splice(4, 1);
        this.historyList.unshift({ name: this.game });
      }
      localStorage.historyList = JSON.stringify(this.historyList);
    }
  }
  // 获取热搜
  public async getHotList() {
    const res = await hotSearch({ token: this.$fn.cookies.getToken() });
    if (res.code == 200) {
      this.hotList = res.data.hot;
      if (this.$store.state.user.info) {
        this.historyList = res.data.history;
      }
    }
    this.showSearch = true;
  }
  // 模糊查询
  public async fuzzyQuery() {
    const res = await queryPrefix({ cueword: this.game });
    if (res.code == 200) {
      this.showSearch = false;
      this.fuzzyList = res.data.cueword;
      this.showQuery = true;
    }
  }
  // 删除单个历史
  public async removeGame(i, j) {
    if (this.$store.state.user.info) {
      const obj = {
        token: this.$fn.cookies.getToken(),
        id: j,
      };
      const res = await delSingleHistory(obj);
    }
    this.historyList.splice(i, 1);
    localStorage.historyList = JSON.stringify(this.historyList);
  }
  // 清除历史
  public async removeHistory() {
    if (this.$store.state.user.info) {
      const arr = this.historyList.map((item) => {
        return item.id;
      });
      const obj = {
        token: this.$fn.cookies.getToken(),
        id: arr,
        uid: this.$store.state.user.info.id,
      };
      const res = await delHistory(obj);
    }
    this.historyList = [];
    localStorage.historyList = JSON.stringify(this.historyList);
  }
  public closeSearch() {
    setTimeout(() => {
      this.showSearch = false;
      this.showQuery = false;
    }, 300);
  }
  public toSearch(name) {
    this.game = name;
    this.$router.push({
      path: "/search",
      query: { game: name },
    });
  }
  public async loginOut() {
    const res = await logout({ token: this.$fn.cookies.getToken() });
    if (res.code == 200 || res.code == 50008) {
      localStorage.removeItem("tempLogin");
      this.$fn.cookies.removeToken();
      this.$router.push({ path: "/home" });
      localStorage.setItem("logout", "popout");
    } else {
      this.$Message.error(res.msg);
      return;
    }
    (window as any).location.reload();
  }
  // 登录
  public pleaseLogin() {
    if (sessionStorage.getItem("modal")) return;
    sessionStorage.setItem("modal", "true");
    (this as any).$toast(true, true);
  }
  // 注册账号
  public async createAccount() {
    if (sessionStorage.getItem("modal")) return;
    sessionStorage.setItem("modal", "true");
    const $createAccount: any = this.$refs.createAccount;
    const res = await $createAccount.show();
  }
  public loginModal() {
    if (localStorage.getItem("logout")) {
      localStorage.removeItem("logout");
      (this as any).$toast(true, true);
    }
    sessionStorage.removeItem("modal");
  }
  // 判断是否为默认头像
  // public validate(value) {
  //   const h = value.substring(value.lastIndexOf(".") + 1, value.length);
  //   if (h.toLocaleLowerCase() == "png") {
  //     return true;
  //   }
  //   return false;
  // }
  public iconAdd() {
    this.game = this.cueword;
    this.searchGame();
  }
  public mounted() {
    if (this.$route.path == "/996news") {
      this.navList[1].path = "/996news";
    }
    // 防止页面刷新，导航栏失去焦点
    for (let i = 0; i < this.navList.length; i++) {
      if (this.navList[i].path == this.$route.path) {
        this.limit = i;
      }
    }
    if (this.$route.path == "/downloads") {
      this.routeActive = true;
    } else if (this.$route.name == "gameDetail") {
      this.routeActive = true;
    } else {
      this.routeActive = false;
    }
    this.getWord();
    // 监听滚动条
    window.addEventListener("scroll", this.handleScroll, true);
    this.loginModal();
  }
  public handleScroll() {
    // let windowScrollY = window.scrollY;
    const windowScrollY =
      window.pageYOffset || // 用于FF
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    // console.log(windowScrollY);
    if (windowScrollY > 500) {
      // 当滚动大于一屏高度时的操作
      this.showToTop = true;
      //   console.log(11);
    } else {
      // 当滚动小于于一屏高度时的操作
      this.showToTop = false;
      //   console.log(22);
    }
  }
  public toTop() {
    if (document.documentElement.scrollTop > 0) {
      setTimeout(() => {
        document.documentElement.scrollTop =
          document.documentElement.scrollTop - 10;
        this.toTop();
      });
    }
  }
}
